module.exports = __webpack_public_path__ + "static/media/studentlife--resized2.0d8ec67a.jpg";